module.exports = __webpack_public_path__ + "static/img/comIcon5.8732fba8.png";